import { createSelector } from 'reselect'
import config from 'constants/config'
import { PASSPORT_CARD_UTM_CAMPAIGN } from 'constants/insurance'
import { isPassportCardStartDateWithinAllowedRange } from 'checkout/Components/CheckoutSteps/Review/PassportCardInsurance/passportCardUtils'
import getInsuranceDatesFromCart from './getInsuranceDatesFromCart'
import { hasPassportCardEligibleItems } from '../view/itemViews/getPassportCardQuoteItems'

export function isPassportCardUtmCampaign(utmCampaign: string | undefined): boolean {
  return utmCampaign?.toLowerCase() === PASSPORT_CARD_UTM_CAMPAIGN
}

// Non-spoofed PassportCard entry point: lets PassportCard trial their product
// against LE checkout for any user landing with `utm_campaign=passportcard`.
// Restricted to non-production environments. Mirrors the eligibility guards of
// isPassportCardInsuranceSupportedSpoofed (AU region, valid start date, eligible
// cart items) with the isSpoofed check swapped for the UTM + environment gate.
const isPassportCardInsuranceSupportedViaCampaign = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (state: App.State) => isPassportCardUtmCampaign(state.utm.campaign),
  (state: App.State) => getInsuranceDatesFromCart(state)?.startDate,
  (state: App.State) => hasPassportCardEligibleItems(state),
  () => config.APP_ENV,
  (
    regionCode,
    isCampaign,
    checkoutStartDate,
    cartHasEligibleItems,
    appEnv,
  ): boolean => {
    if (appEnv === 'production') return false
    if (!isCampaign) return false
    if (regionCode !== 'AU') return false
    if (!isPassportCardStartDateWithinAllowedRange(checkoutStartDate)) return false
    return cartHasEligibleItems
  },
)

export default isPassportCardInsuranceSupportedViaCampaign
